import { showToast } from '@/features/toasts/toastsSlice';
import { useWorkspace } from '@/features/workspaces/hooks';
import { DeleteModalWithConfirmInput } from '@/lib/Modals';
import { Audience } from '@/models/audiences';
import { ConnectorFlowInstanceDTO } from '@/models/connectors';
import { ToastType } from '@/models/toast';
import { useAppDispatch } from '@/reducers';
import { useDeleteConnectorFlowInstanceMutation } from '@/services/endpoints/workspace-connectors';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

type DisconnectFlowInstanceModalProps = {
  audience: Audience;
  flowInstance: ConnectorFlowInstanceDTO;
  closeModal: VoidFunction;
};

export const DisconnectFlowInstanceModal: FC<DisconnectFlowInstanceModalProps> = ({ flowInstance, closeModal }) => {
  const workspace = useWorkspace();
  const dispatch = useAppDispatch();
  const { t } = useTranslation('audience_details');

  const [deleteFlowInstance, { isLoading, isSuccess }] = useDeleteConnectorFlowInstanceMutation();

  const handleDeleteClicked = async () => {
    deleteFlowInstance({
      workspaceId: workspace.id,
      id: flowInstance.id,
    });
  };

  useEffect(() => {
    if (isSuccess) {
      closeModal();

      dispatch(
        showToast({
          type: ToastType.SUCCESS,
          title: t('disconnect.success_title'),
          message: t('disconnect.success_body', { destinationName: 'Custom Connector Flow' }),
        })
      );
    }
  }, [isSuccess]);

  return (
    <DeleteModalWithConfirmInput
      inputComparisonValue='Custom Connector Flow'
      confirmText='audience_details.disconnect.confirm_button'
      onConfirm={handleDeleteClicked}
      onClose={closeModal}
      isLoading={isLoading}
    >
      <DeleteModalWithConfirmInput.Title>{t('disconnect.confirm_title')}</DeleteModalWithConfirmInput.Title>

      <DeleteModalWithConfirmInput.InputHint>
        {t('disconnect.confirm_body')} &nbsp;(<b>Custom Connector Flow</b>)
      </DeleteModalWithConfirmInput.InputHint>
    </DeleteModalWithConfirmInput>
  );
};
